import React from "react";

function NotificationBadge({ number, backgroundColor, collapsed }) {
  const styles = {
    backgroundColor,
    borderRadius: "50%",
    fontSize: "12px",
    color: "white",
    width: "20px",
    height: "20px",
    display: collapsed ? "none" : "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  return <div style={styles}>{number}</div>;
}
export default NotificationBadge;
